import { transport } from 'config/transport';

export function callApiSaveThuChiDauNamNhiemKy(congDoanId, academicYear, body) {
    return transport.post(`/mamnon/cong-doan/${congDoanId}/thuchidaunam-nhiemky`, body, { params: { academicYear } });
}
